module.exports = __webpack_public_path__ + "mo/img/piece-20.b2039344.svg";